// Pillar guide (mem://guides) and related services per service slug.
// Used by ServicioPage to render contextual internal links.

import type { ServiceSlug } from "./service-slugs";

export const SERVICE_LABELS: Record<ServiceSlug, string> = {
  "publicidad-meta": "Meta Ads",
  "publicidad-tiktok": "TikTok Ads",
  "redes-sociales": "Redes Sociales",
  "google-ads": "Google Ads",
  "chatgpt-ads": "ChatGPT Ads",
  seo: "SEO",
  "seo-local": "SEO Local",
  consultoria: "Consultoría",
  "web-corporativa": "Web Corporativa",
  "tienda-online": "Tienda Online",
  "crm-implementacion": "CRM",
  branding: "Branding",
  "landing-page": "Landing Page",
  "email-marketing": "Email Marketing",
  automatizacion: "Automatización",
  "mantenimiento-web": "Mantenimiento Web",
  incubadora: "Incubadora",
};

// Map service slug → pillar guide slug (in /guias/<slug>)
export const SERVICE_GUIDE: Partial<Record<ServiceSlug, string>> = {
  "publicidad-meta": "publicidad-meta",
  "publicidad-tiktok": "publicidad-tiktok",
  "google-ads": "google-ads",
  seo: "seo",
  "seo-local": "seo-local",
  "redes-sociales": "redes-sociales",
  "email-marketing": "email-marketing",
  "mantenimiento-web": "mantenimiento-web",
  "crm-implementacion": "crm",
  consultoria: "consultoria-branding",
  branding: "consultoria-branding",
  "web-corporativa": "web-corporativa",
  "tienda-online": "websites",
  "landing-page": "landing-pages",
  incubadora: "incubadora",
};

// 2-3 related services per slug for cross-linking at the bottom of each page
export const RELATED_SERVICES: Record<ServiceSlug, ServiceSlug[]> = {
  "publicidad-meta": ["publicidad-tiktok", "google-ads", "redes-sociales"],
  "publicidad-tiktok": ["publicidad-meta", "redes-sociales", "google-ads"],
  "chatgpt-ads": ["google-ads", "seo", "publicidad-meta"],
  "google-ads": ["seo", "publicidad-meta", "seo-local"],
  seo: ["seo-local", "google-ads", "mantenimiento-web"],
  "seo-local": ["seo", "google-ads", "redes-sociales"],
  "redes-sociales": ["publicidad-meta", "publicidad-tiktok", "email-marketing"],
  "email-marketing": ["redes-sociales", "crm-implementacion", "automatizacion"],
  automatizacion: ["crm-implementacion", "email-marketing", "google-ads"],
  "mantenimiento-web": ["seo", "web-corporativa", "tienda-online"],
  consultoria: ["branding", "crm-implementacion", "incubadora"],
  "web-corporativa": ["landing-page", "tienda-online", "mantenimiento-web"],
  "tienda-online": ["web-corporativa", "publicidad-meta", "mantenimiento-web"],
  "crm-implementacion": ["email-marketing", "consultoria", "publicidad-meta"],
  branding: ["consultoria", "web-corporativa", "landing-page"],
  "landing-page": ["web-corporativa", "publicidad-meta", "google-ads"],
  incubadora: ["consultoria", "branding", "web-corporativa"],
};
